import { format, isValid } from "date-fns"
import { AlertModal } from "../../../../.."
import TruncText from "../../../../../misc/TruncText"
import { store } from "../../../../../stores/Store"
import ViewQuestionnaire from "../../../questionnaire/ViewQuestionnaire"
import Help from "../../../../../misc/Help"
import React from "react"
import { Icons } from "../../../../../misc/Icons"
import { UTCDate } from "@date-fns/utc"


export default function EnquiryDataSourcesSection () {

    const {enquiry} = store.EnquiryStore

    var sources_grouped = []

    enquiry.dataSources?.forEach((source) => {
        var existing_item = sources_grouped.find((o) => source.sourceUid === o.sourceUid)
        if (!existing_item) {
            sources_grouped.push({
                ...source,
                insertedAt: undefined,
                insertedBy: undefined,
                usage: [
                    {date: source.insertedAt, user: source.insertedBy}
                ]
            })
        } else {
            existing_item.usage.push({date: source.insertedAt, user: source.insertedBy})
        }
    })

    return (
        <div className="detail-section">

            <div className="section-header">
                <div className="header-content">
                    <h4>Data sources</h4>
                </div>
            </div>

            {sources_grouped?.map((source, i) => (
                <div className="section-table" style={{marginBottom: "15px"}}>
                    <div className="section-row" key={i}>
                        <div className="section-cell" style={{width: "auto"}}>
                            <Icons.Questionnaire color="primary" />
                        </div>

                        <div className="section-cell link" style={{width: "auto"}} onClick={() => AlertModal({width: "700px", body: <ViewQuestionnaire uid={source.sourceUid} />})}>
                            <TruncText text={source.label ? source.label : "Questionnaire"} />
                        </div>

                        <div className="section-cell font-grey" style={{width: "auto", marginLeft: "auto"}}>
                            <Help content={`Used ${source.usage.length} time${source.usage.length !== 1 ? "s" : ""}`}>
                                <Usage source={source} />
                            </Help>
                        </div>
                    </div>
                </div>
            ))}

            {!sources_grouped?.length ? (
                <div className="section-header section-subheader">
                    <h5>No entries</h5>
                </div>
            ) : null}
        </div>
    )
}


function Usage ({source}) {


    var usage = source.usage?.sort((a,b) => {
        return a.date?.localeCompare(b.date)
    })

    return (
        <div>
            <h3>Data from this source was used {source.usage.length} time{source.usage.length !== 1 ? "s" : ""}</h3>
            <div style={{margin: "10px", display: "grid", gridTemplateColumns: "140px auto"}}>
                <small><b>Time</b></small>
                <small><b>User</b></small>
                {usage.map((usage, i) => {
                    var date = new UTCDate(usage.date)
                    var formattedDate = isValid(date) ? format(date, "dd/MM/yyyy HH:mm") : "Invalid date"
                    return (
                        <React.Fragment key={i}>
                            <small>{formattedDate}</small>
                            <small>{usage.user ? usage.user : "Unknown user"}</small>
                        </React.Fragment>
                    )
                })}
            </div>
        </div>
    )
}